/* @flow */

export default {
  root: {
    minWidth: 12,
    width: 12,
    height: 18,

    transformOrigin: 'center center',
  },
  'root-right': {
    transform: 'rotate(180deg)',
  },
  'root-up': {
    /* Translation is needed because icon is not square */
    transform: 'translate(3px, -3px) rotate(90deg)',
  },
  'root-down': {
    /* Translation is needed because icon is not square */
    transform: 'translate(3px, -3px) rotate(-90deg)',
  },
};
